import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';

export function PositionLockButton({ isLocked, onToggle }: { isLocked: boolean; onToggle: () => void }) {
	return (
		<Tooltip title={isLocked ? 'Unlock positions' : 'Lock positions'} disableInteractive>
			<IconButton onClick={onToggle} sx={{ color: isLocked ? 'primary.main' : 'warning.main' }}>
				{isLocked ? <LockIcon /> : <LockOpenIcon />}
			</IconButton>
		</Tooltip>
	);
}
